export const genderList = [
    { value: 'female', label: 'Feminino' },
    { value: 'male', label: 'Masculino' },
]
